import React from 'react';
import PropTypes from 'prop-types';
import { Text, View, TextInput, Modal as NativeModal } from 'react-native';
import { Button } from 'LocalGluons';
import { t } from 'Locale';
import { noop } from 'Utils';
import styles from './ChannelOrderDialog.jss';
import useOnChange from './useOnChange';

const ChannelOrderDialog = ({ itemTitle, currentPosition, onCancel, onConfirm }) => {
    const { onChangeTextCallback, input } = useOnChange();
    return (
        <NativeModal visible transparent>
            <View style={styles.container}>
                <Text style={styles.title}>{`${t(
                    'SETTINGS.FAVOURITE_CHANNELS_MOVE'
                )} "${itemTitle}"`}</Text>
                <Text style={styles.description}>{`${t(
                    'SETTINGS.FAVOURITE_CHANNELS_MOVE_DECRIPTION'
                )} "${itemTitle}"`}</Text>
                <TextInput
                    style={styles.input}
                    placeholder={`${t(
                        'SETTINGS.FAVOURITE_CHANNELS_CURRENT_POSITION'
                    )}: ${currentPosition}`}
                    onChangeText={onChangeTextCallback}
                    value={input}
                />
                <View style={styles.buttonsContainer}>
                    <Button
                        style={{ button: { marginRight: 10 } }}
                        title={t('COMMON.BTN_CANCEL')}
                        onPress={onCancel}
                        isSecondary
                    />
                    <Button title={t('COMMON.OK')} onPress={() => onConfirm(input)} />
                </View>
            </View>
        </NativeModal>
    );
};

ChannelOrderDialog.defaultProps = {
    onCancel: noop,
    onConfirm: noop
};

ChannelOrderDialog.propTypes = {
    itemTitle: PropTypes.string.isRequired,
    currentPosition: PropTypes.number.isRequired,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
};

export { ChannelOrderDialog };
